export default __webpack_public_path__ + "static/media/banner8.dfd56481.jpg";